module.exports = __webpack_public_path__ + "static/media/flower2.2faf69c0.png";